module.exports = __webpack_public_path__ + "img/place_centre_bw.1290e363.png";